const poInfoReport = {
  label: "PO Info Report",
  name: "poInfoReport",
  parameters: [
    {
      name: "program",
      label: "Program",
      type: "dbfield",
      db: ["hero", "data"],
      table: "Program",
      keyField: "ProgramAssociatedId",
      valueField: "ProgramAssociatedId",
      fields: ["Program.ProgramAssociatedId"],
      distinct: true,
      where: {
        ProgramAssociatedId: {
          null: false,
        },
      },
      sort: {
        ProgramAssociatedId: "asc",
      },
    },
  ],
};

export default poInfoReport;
